import api from "./api";

describe("api", () => {
    it("fetches data from url", () => {
        expect.assertions(2);
        const url = "testurl";
        const data = { test: "test" };
        const fetchMock = jest.fn(
            () =>
                new Promise((resolve) => {
                    resolve({ ok: true, json: () => data });
                })
        );
        // eslint-disable-next-line
        (globalThis as any).fetch = fetchMock;
        return api(url).then((result) => {
            expect(fetchMock).toHaveBeenCalledWith(url);
            expect(result).toEqual(data);
        });
    });

    it("throws an error if response is not ok", () => {
        expect.assertions(1);
        const errorCallback = jest.fn();
        const fetchMock = jest.fn(
            () =>
                new Promise((resolve) => {
                    resolve({ ok: false });
                })
        );
        // eslint-disable-next-line
        (globalThis as any).fetch = fetchMock;
        return api("url")
            .catch(errorCallback)
            .then(() => {
                expect(errorCallback).toHaveBeenCalled();
            });
    });
});
